const wwcalcConfig = {
  interviewType: 'wwcalc',
  avatars: [
    {
      id: 'default',
      label: 'Padrão',
      path: 'eia/media/wwcalc'
    }
  ],
  features: {
    captions: true,
    speed: true,
    audio: true,
    avatarPicker: true
  },
  videoSequence: [
    "intro", "s1p1", "s1p2", "s1p3", "s1p4", "s1p5",
    "s2p1", "s2p2", "s2p3", "s2p4", "s2p5",
    "s3p1", "s3p2", "s3p3", "s3p4", "s3p5",
    "s4p1", "s4p2", "fim"
  ]
};

export default wwcalcConfig;
